import type {
  MentorMe,
  MentorProfileFormValues,
  UpdateMentorMeRequest,
} from './types';

export function unwrapMentorMe(response: unknown): MentorMe {
  if (response && typeof response === 'object' && 'data' in response) {
    const envelope = response as { data?: MentorMe };
    if (envelope.data && typeof envelope.data === 'object') {
      return envelope.data;
    }
  }
  return response as MentorMe;
}

export function toMentorProfileFormValues(
  mentor: MentorMe | null | undefined,
): MentorProfileFormValues {
  const profile = mentor?.profile;
  return {
    displayName: profile?.displayName ?? '',
    headline: profile?.headline ?? '',
    description: profile?.description ?? '',
    goals: profile?.goals ?? '',
    introVideoUrl: profile?.introVideoUrl ?? '',
    avatarUrl: profile?.avatarUrl ?? '',
    timezone: profile?.timezone ?? '',
    nativeLanguages: profile?.nativeLanguages ?? [],
    experienceYears:
      profile?.experienceYears != null ? String(profile.experienceYears) : '',
    categoryIds: (mentor?.categoryIds ?? []).map(String),
  };
}

export function toUpdateMentorMeRequest(
  values: MentorProfileFormValues,
): UpdateMentorMeRequest {
  const years = values.experienceYears.trim();
  return {
    profile: {
      displayName: values.displayName.trim(),
      headline: values.headline.trim() || null,
      description: values.description.trim() || null,
      goals: values.goals.trim() || null,
      introVideoUrl: values.introVideoUrl.trim() || null,
      avatarUrl: values.avatarUrl.trim() || null,
      timezone: values.timezone.trim() || null,
      nativeLanguages: values.nativeLanguages,
      experienceYears: years === '' ? null : Number(years),
    },
    categoryIds: values.categoryIds
      .map((id) => Number(id))
      .filter((id) => Number.isInteger(id)),
  };
}
